module.exports = __webpack_public_path__ + "assets/img/l1.5bda3b7d.png";